import React, { useEffect, useState } from "react";
import { BiSearchAlt } from "react-icons/bi";
import { TiArrowUnsorted } from "react-icons/ti";

const SpecialSearch = ({
  ready,
  placeholder,
  onSearch,
  query = "",
  limit,
  setLimit,
}) => {
  const [keyword, setKeyword] = useState("title");
  const [searchQuery, setSearchQuery] = useState(query);
  useEffect(() => {
    setSearchQuery(query);
  }, [query]);

  const handleSearchType = (e) => {
    const newKeyword = e.target.value;
    setKeyword(newKeyword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const normalizedKeyword = keyword.toLowerCase();
    if (onSearch && searchQuery) {
      onSearch({
        searchQuery,
        limit,
        keyword: normalizedKeyword,
        offset: 0,
      });
    }
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
  };

  return (
    <>
      <div className="search-container">
        <div>
          <div className="search-select-container">
            <select value={limit} onChange={handleLimitChange}>
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </select>
            <TiArrowUnsorted
              className="search-custom-arrow"
              size={18}
              color="#a6a8aa"
            />
          </div>
          <span className="search-select-text">records per page</span>
        </div>
        {ready && (
          <div className="search-select-container search-dropdown">
            <select value={keyword} onChange={handleSearchType}>
              <option>Title</option>
              <option>Year</option>
            </select>
            <TiArrowUnsorted
              className="search-custom-arrow"
              size={18}
              color="#a6a8aa"
            />
          </div>
        )}
        <form className="search-box" onSubmit={handleSubmit}>
          <input
            type="text"
            name="search"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button>
            <BiSearchAlt size={16} style={{ transform: "scaleX(-1)" }} />
            Search
          </button>
        </form>
      </div>
    </>
  );
};

export default SpecialSearch;
